document.addEventListener("contextmenu", function (e) {
  if (e.target.tagName === "IMG") {
    e.preventDefault();
  }
});

document.addEventListener("keydown", function (e) {
  // F12
  if (e.key === "F12") {
    e.preventDefault();
  }

  // Ctrl+Shift+I / J / C
  if (
    e.ctrlKey &&
    e.shiftKey &&
    ["I", "J", "C"].includes(e.key.toUpperCase())
  ) {
    e.preventDefault();
  }

  // Ctrl+U (View Source)
  if (e.ctrlKey && e.key.toLowerCase() === "u") {
    e.preventDefault();
  }
});

document.addEventListener("contextmenu", function (e) {
  e.preventDefault();
});

document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll("img");

  images.forEach((img) => {
    // Disable right-click
    img.addEventListener("contextmenu", (e) => e.preventDefault());

    // Disable long-press (mobile/tablet)
    let touchTimer;
    img.addEventListener("touchstart", () => {
      touchTimer = setTimeout(() => {
        // Optional: Add a visual cue or block interaction
      }, 500); // threshold for long press
    });
    img.addEventListener("touchend", () => clearTimeout(touchTimer));
    img.addEventListener("touchmove", () => clearTimeout(touchTimer));

    // Optional: Prevent text/image selection
    img.style.userSelect = "none";
    img.style.webkitUserSelect = "none";
    img.style.pointerEvents = "none"; // comment this if image needs to be clickable
  });

  let lastScrollTop = 0;

  window.addEventListener("scroll", function () {
    const currentScroll = window.scrollY;
    const widgets = document.querySelectorAll(
      ".gw-widget-placeholder-BL-wrapper, #chat-bubble"
    );

    widgets.forEach((widget) => {
      if (currentScroll > lastScrollTop) {
        // Scrolling down
        widget.classList.add("hide-on-scroll");
      } else {
        // Scrolling up
        widget.classList.remove("hide-on-scroll");
      }
    });

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
});

// Function to apply direction:ltr if .money is found
function applyLTRDirection() {
  document.querySelectorAll(".removable-facet").forEach((facet) => {
    const money = facet.querySelector(".money");
    const subdued = facet.querySelector(".text-subdued");

    if (money && subdued) {
      subdued.style.direction = "ltr";
      // Or use a class: subdued.classList.add('ltr-text');
    }
  });
}

// Run once immediately (for already-rendered elements)
applyLTRDirection();

// Set up MutationObserver
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      applyLTRDirection();
    }
  });
});

// Observe the body or a more specific container (like the filter wrapper)
const container = document.querySelector("body"); // Replace with a more specific container if possible
if (container) {
  observer.observe(container, {
    childList: true,
    subtree: true,
  });
}

document.addEventListener("click", function (event) {
  const buyButton = event.target.closest(".custom-buy-button");
  if (buyButton) {
    const variantId = buyButton.getAttribute("data-variant-id");
    const quantityInput = document.querySelector(".quantity-selector__input");
    const quantity = parseInt(quantityInput?.value, 10) || 1;
    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to add item to the cart");
        }
        return response.json();
      })
      .then(() => {
        window.location.href = "/checkout";
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
});
